import React from "react";
import style from "./PrimeraParte.module.css";

const PrimeraParte = ({ t }) => {
  return (
    <div className={style.container}>
      <h2 className={style.titulo}>{t("Products.SmartSSC.FirstPart.title")}</h2>

      <div className={style.divContainer}>
        {/* IZQUIERDA */}
        <div className={style.divIzq}>
          <p className={style.text}>{t("Products.SmartSSC.FirstPart.text")}</p>
          <p className={style.text}>{t("Products.SmartSSC.FirstPart.text2")}</p>
          <p className={style.text}>{t("Products.SmartSSC.FirstPart.text7")} {t("Products.SmartSSC.FirstPart.text8")}</p>
          <p className={style.text}>{t("Products.SmartSSC.FirstPart.text3")} {t("Products.SmartSSC.FirstPart.text4")}</p>
          <p className={style.text}>{t("Products.SmartSSC.FirstPart.text5")} {t("Products.SmartSSC.FirstPart.text6")}</p>
        </div>

        {/* DERECHA */}
        <div className={style.divDer}>
          <p className={style.title}>
            {t("Products.SmartSSC.FirstPart.title3")}
          </p>
          <div className={style.separador}></div> 

          <ul className={style.ul}>
            <li className={style.li}>{t("Products.SmartSSC.FirstPart.li")}</li>
            <li className={style.li}>{t("Products.SmartSSC.FirstPart.li4")}</li>
            <li className={style.li}>{t("Products.SmartSSC.FirstPart.li6")}</li>
            <li className={style.li}>{t("Products.SmartSSC.FirstPart.li8")}</li>
            <li className={style.li}>{t("Products.SmartSSC.FirstPart.li12")}</li>
          </ul>
          <p className={style.text}>{t("Products.SmartSSC.FirstPart.text10")} {t("Products.SmartSSC.FirstPart.text11")}</p>
          <p className={style.text}>{t("Products.SmartSSC.FirstPart.text12")}</p>
        </div>
      </div>
    </div>
  );
};

export default PrimeraParte;
